/* eslint-disable @typescript-eslint/naming-convention */

import { EntityBase } from "../../shared/entity-base";

// New artifact classes
export interface ArtifactAssemblyInfoDto {
    Name: string;
    Description: string;
    Filename: string;
    AssemblyType: string;
    AssemblyTypeDisplayName: string;
    IsDeprecated: boolean;
    AssemblyName: string;
    ClassName: string;
}

export interface ArtifactAssemblyDto extends ArtifactAssemblyInfoDto {
    ArtifactId: string;
    ArtifactTypeId: number;
    IsSystemArtifact: boolean;
    CreatedDate: Date;
    CreatedBy: number;
    UpdatedDate: Date;
    UpdatedBy: number;
}

export interface UploadedArtifactAssemblyDto extends ArtifactAssemblyDto {
    UploadFileGuid: string;
}


// Old artifact classes
export interface AssemblyArtifactDto extends AssemblyArtifact {
    AssemblyTypeDisplayName: string;
    IsDeprecated: boolean;
}

export interface Artifact extends EntityBase {
    ArtifactId: string | null;
    ArtifactTypeId: number;
    Name: string;
    Description: string;
    Filename: string;
    IsSystemArtifact: boolean;
    UploadFileGuid: string | null;
}

export interface AssemblyArtifact extends Artifact {
    AssemblyType: string;
    AssemblyName: string;
    ClassName: string;
    IsInternal: boolean;
}

export interface XmlArtifact extends Artifact {
    XmlType: string;
}

export interface ArtifactAssemblyInfo {
    Type: string;
    ClassName: string;
    AssemblyName: string;
    Name: string;
    Description: string;
}

export interface ArtifactXmlInfo {
    XmlType: string;
    Filename: string;
}

/**
 * The main-types of artifacts
 * */
export enum ArtifactType {
    Assembly,
    Xml
}

/**
 * The different types of assembly-implementations
 * */
export class ArtifactAssemblyTypes {
    static TypeTransportRetrieve = 'TransportRetrieve';
    static TypeTransportSend = 'TransportSend';
    static TypeItineraryStep = 'ItineraryStep';
    static TypeInitStep = 'InitStep';
    static TypeIntegratedFtpProvider = 'IntegratedFtpProvider';
    static TypeFormatTypeProbe = 'FormatTypeProbe';
    static TypeComparePlugin = 'ComparePlugin';
    static TypeDuplicateCheck = 'DuplicateCheck';
    static TypeMonitorType = 'MonitorType';
    static TypeDocumentTypeClassiferResolver = 'DocumentTypeClassiferResolver';
    static TypeControlMessageInResolver = 'ControlMessageInResolver';
    static TypeStatusEventHandler = 'StatusEventHandler';
    static TypeHttpHandler = 'HttpHandler';
    static TypeAdvancedHttpHandler = 'AdvancedHttpHandler';
    static TypeMcpServer = 'McpServer';
    static TypeBatcher = 'Batcher';
    static TypeSenderPartnerResolver = 'SenderPartnerResolver';
    static TypeReceiverPartnerResolver = 'ReceiverPartnerResolver';
    static TypeSchedulerTaskHandler = 'SchedulerTaskHandler';
    static TypeItineraryStep2 = 'ItineraryStep2';
    static TypeStatusEventHandler2 = 'StatusEventHandler2';
    static TypeReceiverPartnerResolver2 = 'ReceiverPartnerResolver2';
    static TypeHttpHandler2 = 'HttpHandler2';
    static TypeFormatTypeProbe2 = 'FormatTypeProbe2';
    static TypeIntegratedFtpProvider2 = 'IntegratedFtpProvider2';
    static TypeDuplicateCheck2 = 'DuplicateCheck2';
    static TypeSenderPartnerResolver2 = 'SenderPartnerResolver2';
    static TypeDocumentTypeClassiferResolver2 = 'DocumentTypeClassiferResolver2';
    static TypeControlMessageInResolver2 = 'ControlMessageInResolver2';
    static TypeTrackingAction = 'TrackingAction';
}

/**
 * The different types of xml-documents we support
 * */
export class ArtifactXmlTypes {
    static TypeSchema = 'Schema';
    static TypeXslt = 'Xslt';
}
